<template>
  <div>
    <PageHeader :page_title="page_header"/>
    <pSpinner v-if="loading"></pSpinner>
    <template v-if="!loading">
      <v-tabs  v-model="active_tab1" color="grey  lighten-3" dark  slider-color = "primary" >
        <v-tab ripple class = "black--text ml-4" v-for="tab of tabs"  :key="tab.id"  @click="redirectTo(tab.id,tab.link)" >
          {{tab.name}}
        </v-tab>
      </v-tabs>
      <div >
        <v-form  class="mx-1" v-model="valid_form" autocomplete = "off" ref="form"  lazy-validation>
          <v-layout wrap align-center class="mt-3 ml-3">
            <v-flex xs12 md2 class="pr-3">
              <v-menu lazy  :close-on-content-click="true" v-model="menu_from_date"  transition="scale-transition"  offset-y  full-width :nudge-right="40" max-width="290px" min-width="290px" >
                <v-text-field slot="activator" label="From Date" v-model="formated_from_date"  prepend-icon="event" @blur="from_date = parseDate(formated_from_date)"></v-text-field>
                <v-date-picker v-model="from_date" @input="formated_from_date = formatDate($event)" no-title scrollable actions>
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex md2 xs12 class="pr-3">
              <v-menu lazy :close-on-content-click="true" v-model="menu_to_date" transition="scale-transition" offset-y full-width :nudge-right="40" max-width="290px" min-width="290px" >
                <v-text-field slot="activator" label="To Date" v-model="formated_to_date" prepend-icon="event"  @blur="to_date = parseDate(formated_to_date)"></v-text-field>
                <v-date-picker v-model="to_date"  @input="formated_to_date = formatDate($event)" no-title scrollable actions>
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-btn xs12 sm6  :disabled="!valid_form" color="primary"  @click="getDataFromApi"> Show </v-btn>
          </v-layout> 
        </v-form>  
      </div>      
      
      <v-container fluid>
        <template>
          <v-data-table   hide-actions  :items="ledger_data" select-all item-key="id" class="elevation-1" :pagination.sync="pagination"  style="margin-bottom: 3rem;width: 100%;">
            <template slot="headers" slot-scope="props">
              <tr bordercolor="red" style="background-color:#eceff1;">
                <th class = "header-style" style="text-align:left;color: black;font-size: 14px;">Vou. ID</th>
                <th class = "header-style" style="text-align:left;color: black;font-size: 14px;">Date</th>
                <th class = "header-style" style="text-align:left;color: black;font-size: 14px;">Narration</th>
                <th  class = "header-style" style="text-align:right;color: black;font-size: 14px;">Credit</th>
                <th  class = "header-style" style="text-align:right;color: black;font-size: 14px;">Debit</th>
                <th  class = "header-style" style="text-align:right;color: black;font-size: 14px;">Principal Balance</th>
              </tr>
            </template>
            <template slot="items" slot-scope="props">
             
              
              <tr class="text-xs-left"  v-if="props.item.no_data">
                <td class="text-xs-left"  colspan="5" >{{props.item.no_data}}</td>
                <td class="text-xs-right">{{ props.item.balance }}</td>
              </tr>
                  <tr v-else-if="props.item.opening_balance">
                <td class="text-xs-left"  colspan="5" ><b>Opening balance as on {{opening_balance_from_date}} </b></td>
                <td class="text-xs-right"><b>{{props.item.opening_balance}}</b></td>
              </tr>     
              <tr v-else="props.item.no_data">
                <td class="text-xs-left">{{ props.item.voucher_id }}</td>
                <td class="text-xs-left">{{ props.item.activated_on }}</td>
                <td class="text-xs-left">{{ props.item.custm_narration }}</td>
                <td class="text-xs-right">{{ props.item.debit_account_amount }}</td>
                <td class="text-xs-right">{{ props.item.credit_account_amount }}</td>
                <td class="text-xs-right">{{ props.item.balance }}</td>
              </tr>
              
               
            </template>
            
       
          </v-data-table>
          <div v-if="pagination.total > 1" class="text-xs-center pt-3"  style="padding-bottom: 1.5rem; margin-top: -40px;">
            <v-pagination v-model="pagination.current" :total-visible="5" :length="pagination.total" @input="onPageChange"></v-pagination>
          </div>
        </template>
      </v-container>
    </template>
  </div>
</template>

<script>

  import axios from 'axios'
  
  import moment from 'moment'

  import NoData from '@/components/NoData'
  
  import pSpinner from '@/components/pSpinner';
  
  import PageHeader from '@/components/PageHeader'
  
  import global from '@/components/rbconstants';

  export default {

    components : {
      
      NoData : NoData,
      
      PageHeader : PageHeader,
      
      pSpinner : pSpinner,
    
    },  
    
    mounted() {
      
        this.getDataFromApi()
        
    },
      
    data: () => ({
        
        page_title : "Savings Deposit Ledger - ",
              
        to_date: '',
        
        from_date: '',
        
        date_starts_before: 30,
        
        formated_from_date: moment().subtract(30, 'days').format("DD-MM-YYYY"),
        
        formated_to_date: moment().format("DD-MM-YYYY"),
        
        ledger_data : [],
        
        opening_balance: '',
        
        ledger_table_headers : [{ text: '#'}, { text : 'Vou. ID'}, { text : 'Date'}, { text : 'Narration'}, { text : 'Debit'},
                               { text : 'Credit'}, { text : 'Principal Balance'}],
        
        active_tab1: 1,
        
        tabs: [
          
          { id: 1, name: "Account Details", route: "deposits/savings/:id" },
          { id: 2, name: "Ledger", route: "deposits/savings/:id/ledger" }
        
        ],
        
        loading : false,
        
        valid_form: true,
        
        menu_to_date: false,
        
        menu_from_date: false,   
        
        pagination : {
                 
            current : 1,
            
            total: 0,
            
            rowsPerPage: 5
        
        },
        
        itemsperpage : 50,
        
        page_header:'',
        
        opening_balance_from_date: '',
         
    }),
    
    methods : {
      
      formatDate (date) {
          
          if (!date) {
            
            return null
            
          }

          const [year, month, day] = date.split('-')
          
          return `${day}-${month}-${year}`
      },        
      
      parseDate (date) {
            
            if (!date) {
              
              return null
            
            }
    
            const [ day,month, year] = date.split('-')
            
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        }, 
    
      getDataFromApi() {
        
        this.loading = true;
        
        this.table_loading = true
        
        return new Promise((resolve, reject) => {
        
          var app = this;
          
          var form_post_data = {};
          
            if(!app.from_date){
                
                var from_date_requested =  moment().subtract(app.date_starts_before, 'days').format("DD-MM-YYYY")
                
                app.opening_balance_from_date = moment().subtract(app.date_starts_before, 'days').format("DD-MM-YYYY")
            
            } else {
            
                var from_date_requested = app.from_date
                
                app.opening_balance_from_date = moment(app.from_date).format('DD-MM-YYYY')
                
            }
                
            if(!app.to_date) {
               
              var to_date_requested = moment().format("DD-MM-YYYY")
                
            } else {
                
              var to_date_requested = app.to_date
            }
                      
          
          var link = global.links.savings_deposit_ledger;
          
          var deposit_id = this.$route.params.id
          
          link = link.replace(':id',deposit_id);
           
          axios.post(link, {
            
            from_date : from_date_requested,
            
            to_date : to_date_requested,
            
            itemsperpage:  app.itemsperpage,
            
            page: app.pagination.current
  
          }, { headers : global.header }) .then(function (response) {
            
            app.loading = false
            
            if(response.status == 200) {
            
            app.ledger_data = response.data.data.txns;
            
            app.opening_balance = response.data.data.opening_balance
           
            app.page_header = app.page_title+response.data.data.account_id
                            
            app.pagination.current = response.data.data.pagination.current_page
            
            app.pagination.total = response.data.data.pagination.total_pages
            
            app.pagination.rowsPerPage = response.data.data.pagination.items_per_page
            
            document.title = 'Savings Deposit Ledger '+response.data.data.account_id+' - '+global.app_name
            
            app.table_loading = false
            
            app.loading = false
          
          }
          
          }) .catch(function (error) {
            
            if(error.response.data.error.code == 400) {
              
              app.$router.push({ name: 'DepositList',  params: { alert: true}})

            }
         
            app.loading = false;
          
          });
        
        });
        
      },
      
      redirectTo(id, link) {
      
        if(id == 1) {
          
          var id = this.$route.params.id;
          
          this.$router.push({ name: 'SavingsDeposit', params: { id: id}});
        
        } else if(id == 2) {
          
          var id = this.$route.params.id;
          
          this.$router.push({ name: 'SavingsDepositLedger', params: { id: id}});
          
        }
      
      },
      
      onPageChange() {
      
        this.getDataFromApi()
      
      },
    
    },

  }
  
</script>
